/** Printable student-table columns and hide-class helpers. */

export const STUDENT_PRINT_COLUMNS = [
  { id: 'info', label: 'Student Info', required: true },
  { id: 'services', label: 'Services' },
  { id: 'schedule', label: 'Schedule' },
  { id: 'instruction', label: 'Instruction Accommodations' },
  { id: 'assessment', label: 'Assessment Accommodations' },
  { id: 'docs', label: 'Documents' }
]

export const DEFAULT_PRINT_COLUMNS = Object.freeze({
  info: true,
  services: true,
  schedule: true,
  instruction: true,
  assessment: true,
  docs: false
})

const OPTIONAL_IDS = STUDENT_PRINT_COLUMNS.filter((c) => !c.required).map((c) => c.id)

export function normalizePrintColumns(raw) {
  const next = { ...DEFAULT_PRINT_COLUMNS }
  if (raw && typeof raw === 'object') {
    for (const id of OPTIONAL_IDS) {
      if (typeof raw[id] === 'boolean') next[id] = raw[id]
    }
  }
  next.info = true
  return next
}

/** CSS classes applied to `.students-view` so `@media print` can hide columns. */
export function printHideClassList(columns) {
  const cols = normalizePrintColumns(columns)
  return OPTIONAL_IDS.filter((id) => !cols[id]).map((id) => `print-hide-${id}`)
}

export const PRINT_REQUEST_EVENT = 'casemanage:print'
